export const BASE_URL =
  process.env.REACT_APP_BASE_URL ||
  'https://mephalti-backend.onrender.com/api-v1';

const getApiRoute = (path: string) => BASE_URL + path;

export const NEWSLETTER = getApiRoute('/newsletter');

export const CONTACT = getApiRoute('/contact-us');
